/* The droid body in a 100×100 box, centred on (50, 50): the outline with
   its ear knobs, the antenna drawn as a thinner solid, and where the face
   sits on it. */
export const droidShape = {
    key: 'droid',
    outline:
        'M16 50C16 38.95 24.95 30 36 30H64C75.05 30 84 38.95 84 50V70C84 81.05 75.05 90 64 90H36C24.95 90 16 81.05 16 70ZM4 62A7 7 0 1 1 18 62A7 7 0 1 1 4 62ZM82 62A7 7 0 1 1 96 62A7 7 0 1 1 82 62Z',
    parts: 'M47.5 14H52.5V32H47.5ZM43 11A7 7 0 1 1 57 11A7 7 0 1 1 43 11Z',
    faceX: 50,
    faceY: 60,
    faceScale: 0.95,
} as const;
